import React, { useState } from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import {
  Dashboard as DashboardView,
  ProductList as ProductListView,
  UserList as UserListView,
  Typography as TypographyView,
  Icons as IconsView,
  Account as AccountView,
  Settings as SettingsView,
  SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView
} from './views';
import EmpresaList from './views/EmpresaList/EmpresaList';
import EmpresaRegister from './views/EmpresaRegister';
import UsuarioList from './views/UsuarioList';
import UsuarioRegister from './views/UsuarioRegister';
import FiliadoList from './views/FiliadoList';
import ArmaList from './views/ArmaList';
import ArmaRegister from './views/ArmaRegister';
import FiliadoRegister from './views/FiliadoRegister';
import VisitaFiliadoList from './views/VisitaFiliadoList';
import VisitaFiliadoRegisterDetalhado from './views/VisitaFiliadoRegisterDetalhado';
import PreInscricao from './views/PreInscricao';
import RecuperacaoSenha from './views/RecuperacaoSenha';
import InsumoList from './views/InsumoList';
import InsumoRegister from './views/InsumoRegister';
import PacoteList from './views/PacoteList';
import PacoteRegister from './views/PacoteRegister';
import VisitaFiliadoVisualizacao from './views/VisitaFiliadoPreview';
import EstoqueInsumoMovimentacaoList from './views/EstoqueMovimentacaoList/EstoqueInsumoMovimentacaoList';
import FabricaInsumos from './views/FabricaInsumos/FabricaInsumos';
import ConexaoUsuarioList from './views/ConexoesUsuariosList/ConexaoUsuarioList';
import moment from 'moment/moment';
import { getUsuarioByLocalStorage } from './services/UsuarioService';
import LogList from './views/LogList/LogList';

const Routes = () => {
  const [usuarioLogado, setUsuarioLogado] = useState({
    idUsuario: undefined,
    nome: '',
    nomeFantasia: '',
    cpfCnpj: '',
    pessoa_fisica: '',
    email: '',
    sexo: '',
    dataNascimento: null,
    idTipoUsuario: '',
    login: '',
    senha: '',
    createdAt: undefined,
    updatedAt: undefined,
    enderecos: [],
    telefones: [],
    empresas: []
  });
  moment.locale('pt-BR');

  async function getUsuarioLogado() {
    try{
      const usuario = await getUsuarioByLocalStorage();
      if(usuario.isSuccess) {
        if (usuario.result && usuario.result.length > 0) {
          setUsuarioLogado(usuario.result[0]);
        }
      }
    }
    catch (e) {
      console.log('Falha ao obter usuário logado.');
    }
  }
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to="/sign-in"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={DashboardView}
        exact
        layout={MainLayout}
        path="/dashboard"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={EmpresaList}
        exact
        layout={MainLayout}
        path="/empresa-list"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={EmpresaRegister}
        exact
        layout={MainLayout}
        path="/empresa-register"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={EmpresaRegister}
        exact
        layout={MainLayout}
        path="/empresa-edit"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={UsuarioList}
        exact
        layout={MainLayout}
        path="/usuario-list"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={UsuarioRegister}
        exact
        layout={MainLayout}
        path="/usuario-register"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={UsuarioRegister}
        exact
        layout={MainLayout}
        path="/usuario-edit"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={FiliadoList}
        exact
        layout={MainLayout}
        path="/filiado-list"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={InsumoList}
        exact
        layout={MainLayout}
        path="/insumo-list"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={InsumoRegister}
        exact
        layout={MainLayout}
        path="/insumo-register"
      />

      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={InsumoRegister}
        exact
        layout={MainLayout}
        path="/insumo-edit"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={FiliadoRegister}
        exact
        layout={MainLayout}
        path="/filiado-register"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={FiliadoRegister}
        exact
        layout={MainLayout}
        path="/filiado-edit"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={ArmaList}
        exact
        layout={MainLayout}
        path="/arma-list"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={ArmaRegister}
        exact
        layout={MainLayout}
        path="/arma-register"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={ArmaRegister}
        exact
        layout={MainLayout}
        path="/arma-edit"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={VisitaFiliadoList}
        exact
        layout={MainLayout}
        path="/visita-filiado-list"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={VisitaFiliadoRegisterDetalhado}
        exact
        layout={MainLayout}
        path="/visita-filiado-register-detalhado"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={VisitaFiliadoRegisterDetalhado}
        exact
        layout={MainLayout}
        path="/visita-filiado-edit-detalhado"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={VisitaFiliadoVisualizacao}
        exact
        layout={MainLayout}
        path="/visita-filiado-preview"
      />
      <RouteWithLayout
        component={PreInscricao}
        exact
        layout={MinimalLayout}
        path="/pre-inscricao"
      />
      <RouteWithLayout
        component={RecuperacaoSenha}
        exact
        layout={MinimalLayout}
        path="/recuperacao-senha"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={PacoteList}
        exact
        layout={MainLayout}
        path="/pacote-list"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={PacoteRegister}
        exact
        layout={MainLayout}
        path="/pacote-register"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={PacoteRegister}
        exact
        layout={MainLayout}
        path="/pacote-edit"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={AccountView}
        exact
        layout={MainLayout}
        path="/usuario-profile"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={UserListView}
        exact
        layout={MainLayout}
        path="/users"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={ProductListView}
        exact
        layout={MainLayout}
        path="/products"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={TypographyView}
        exact
        layout={MainLayout}
        path="/typography"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={IconsView}
        exact
        layout={MainLayout}
        path="/icons"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={AccountView}
        exact
        layout={MainLayout}
        path="/account"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/sign-up"
      />
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={EstoqueInsumoMovimentacaoList}
        exact
        layout={MainLayout}
        path="/estoque-insumo-movimentacao-list"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={FabricaInsumos}
        exact
        layout={MainLayout}
        path="/fabrica-insumos"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={ConexaoUsuarioList}
        exact
        layout={MainLayout}
        path="/conexao-usuario"
      />
      <RouteWithLayout
        params={{
          getUsuarioLogado: getUsuarioLogado,
          usuarioLogado: usuarioLogado,
          setUsuarioLogado: setUsuarioLogado
        }}
        component={LogList}
        exact
        layout={MainLayout}
        path="/log-list"
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <Redirect to="/not-found" />

      {/*<RouteWithLayout*/}
      {/*  component={EmpresaRegister}*/}
      {/*  exact*/}
      {/*  layout={MainLayout}*/}
      {/*  path="/pacote-register"*/}
      {/*/>*/}

    </Switch>
  );
};

export default Routes;
